module.exports = __webpack_public_path__ + "img/reset-password.34bdb679.png";